import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import StudyRoutinePost from "../../../components/study-routine-post"
import theme from "../../../theme"

const summary = [
  {
    stage: "Primary",
    rhythm: "15 to 25 minutes, 4 days a week",
    focus: "Number facts, place value, mental maths, simple problem solving",
    habit: "Practise a small set of facts, then solve one word problem aloud",
  },
  {
    stage: "Lower secondary",
    rhythm: "25 to 40 minutes, 4 days a week",
    focus: "Core skills, algebra foundations, geometry, working out",
    habit: "Correct mistakes and write why the first attempt went wrong",
  },
  {
    stage: "Upper secondary",
    rhythm: "45 to 70 minutes, 4 to 5 days a week",
    focus: "Topic mastery, exam questions, formula use, multi-step reasoning",
    habit: "Mix current homework with spaced revision from older topics",
  },
  {
    stage: "Exam block",
    rhythm: "Timed sets plus review",
    focus: "Past papers, weak topics, accuracy, speed, calculator routines",
    habit: "Spend as much time reviewing errors as doing new questions",
  },
]

const sections = [
  {
    title: "Primary: make numbers familiar",
    paragraphs: [
      "Primary maths study should build number confidence through short, regular practice. Number facts, place value, fractions, measurement, and simple word problems all benefit from repetition without pressure.",
      "Ask students to explain how they solved a problem. The explanation often reveals more than the final answer.",
    ],
  },
  {
    title: "Lower secondary: show the working",
    paragraphs: [
      "Lower secondary maths needs reliable working habits. Students should write steps clearly, keep equals signs tidy, label diagrams, and correct errors rather than rubbing them away.",
      "A mistake book can be powerful: record the question type, the error, the correct method, and one similar question to try again.",
    ],
  },
  {
    title: "Upper secondary: combine practice and review",
    paragraphs: [
      "Older students need current homework, topic revision, and exam-style questions. The best routine mixes new learning with spaced practice from earlier topics.",
      "Timed sets are useful, but untimed deep work still matters when a concept is shaky. Speed should come after understanding.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a calendar for homework, skill drills, old-topic revision, exam questions, and error review.",
      "A good maths routine is not just more questions. It is questions, corrections, pattern spotting, and another attempt after feedback.",
    ],
  },
]

const MathStudyRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Math Study Plan by School Level"
        description="Plan math study routines for primary, lower secondary, upper secondary, and exam periods with skill practice, revision, error review, and exam questions."
      />
      <StudyRoutinePost
        subject="Math"
        title="Math study routines for different school levels"
        intro="A strong math routine builds fluency, understanding, accuracy, and confidence by combining practice with careful correction."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/bright-penguin-68"
        image="blog-math.png"
        imageAlt="Math study planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default MathStudyRoutines
